var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"-10px"}},[_c('navbar',{staticClass:"navbarBox",attrs:{"select":"0"}}),_c('videoCom',{staticStyle:{"width":"80%","margin":"100px auto"},attrs:{"type":"short"}}),_c('bottom',{directives:[{name:"show",rawName:"v-show",value:(_vm.vShow),expression:"vShow"}],staticClass:"bottomBox"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }